import * as _bookletApi from './bookletApi';
import * as _fragmentApi from './fragmentApi';
import * as _authApi from './authApi';
import * as _sectionApi from './sectionApi';
import * as _uploadApi from './uploadApi';
import * as _commentApi from './commentApi';
import * as _archiveApi from './archiveApi';
import * as _voteApi from './voteApi';
import * as _userApi from './userApi';
import * as _shareApi from './shareApi';
import * as _eventsApi from './eventsApi';
import * as _folderApi from './folderApi';
import * as _extensionApi from './extensionApi';
import * as _presentationApi from './presentationApi';

export const bookletApi = _bookletApi;
export const fragmentApi = _fragmentApi;
export const authApi = _authApi;
export const sectionApi = _sectionApi;
export const uploadApi = _uploadApi;
export const commentApi = _commentApi;
export const archiveApi = _archiveApi;
export const voteApi = _voteApi;
export const shareApi = _shareApi;
export const userApi = _userApi;
export const eventsApi = _eventsApi;
export const folderApi = _folderApi;
export const extensionApi = _extensionApi;
export const presentationApi = _presentationApi;



// WEBPACK FOOTER //
// ./src/services/index.js